let my_account_nav = (function( $ ) {

	let _init = function() {
		_open_my_account_nav();
	};

	let _open_my_account_nav = function() {
		$('#my-account-toggle, #my-account-nav').on({
			mouseenter: function () {
				$('#my-account-nav').show();
			},
			mouseleave: function () {
				$('#my-account-nav').hide();
			}
		});
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = my_account_nav;